import "react-calendar/dist/Calendar.css";
import "./index.css";

import { useCallback, useContext, useState, useEffect } from "react";
import { onValue, push, ref, update } from "firebase/database";
import PWAPrompt from "react-ios-pwa-prompt";

import { auth, database } from "../../firebase/firebase";
import { AuthContext } from "../../contexts/AuthContext";
import ChatToolbar from "../../components/ChatToolbar";
import ChatMessage from "../../components/ChatMessage";
import ChatInputPanel from "../../components/ChatInputPanel";

const Home = () => {
  const { user } = useContext(AuthContext);
  const [chatInput, setChatInput] = useState("");
  const [models, setModels] = useState([]);
  const [temperature, setTemperature] = useState(0.5);
  const [currentModel, setCurrentModel] = useState("text-davinci-003");
  const [chatLog, setChatLog] = useState([]);
  const [loading, setLoading] = useState(false);
  const [effectEnabled, setEffectEnabled] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const scrollToTheBottomChatLog =
      document.getElementsByClassName("chat-log-container")[0];

    scrollToTheBottomChatLog.scrollTop = scrollToTheBottomChatLog.scrollHeight;
  }, [chatLog]);

  const getEngines = useCallback(() => {
    fetch(`${apiUrl}/models`)
      .then((res) => res.json())
      .then((data) => {
        // set models in order alphabetically
        data.models.data.sort((a, b) => {
          if (a.id < b.id) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          }
          return 0;
        });
        setModels(data.models.data);
      });
  }, [apiUrl]);

  const convertDateFormat = (date) => {
    const dateObj = new Date(date);
    const yy = dateObj.getFullYear();
    const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
    const dd = String(dateObj.getDate()).padStart(2, "0");

    return yy + "-" + mm + "-" + dd;
  };

  useEffect(() => {
    if (!auth.currentUser) return;

    const user = auth.currentUser;
    const uid = user.uid;
    const date = convertDateFormat(selectedDate);
    const messagesRef = ref(database, `messages/${uid}/${date}`);

    const unsubscribe = onValue(messagesRef, (snapshot) => {
      const data = snapshot.val();
      const result = [];

      for (const key in data) result.push(data[key]);
      setChatLog(result);
    });

    return () => unsubscribe();
  }, [selectedDate, user]);

  const saveChatInput = (uid, data) => {
    try {
      const date = convertDateFormat(data.createdAt);
      console.log("save", data.createdAt, date);

      return push(ref(database, `messages/${uid}/${date}`), data).key;
    } catch (e) {
      console.error(e);
    }
  };
  const updateChatInput = (uid, chatId, data) => {
    try {
      const date = convertDateFormat(data.createdAt);
      console.log("update", data.createdAt, date);

      return update(ref(database, `messages/${uid}/${date}/${chatId}`), data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user.uid) return;

    let newChatLog = [
      ...chatLog,
      { userId: user.uid, userType: "user", message: chatInput },
    ];
    setChatInput("");
    setSelectedDate(new Date());
    setEffectEnabled(true);
    //save user's message input into firebase real-time database
    saveChatInput(user.uid, {
      userType: "user",
      message: chatInput,
      createdAt: new Date(),
    });
    const newChatKey = saveChatInput(user.uid, {
      userType: "gpt",
      message: "",
      success: true,
      createdAt: new Date(),
    });
    // fetch response to the api combining the chat log array of messages and seinding it as a message to localhost:3000 as a post
    const messages = newChatLog.map((message) => message.message).join("\n");
    try {
      setLoading(true);
      const response = await fetch(`${apiUrl}/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: messages,
          currentModel,
        }),
      });
      setLoading(false);

      const data = await response.json();

      updateChatInput(user.uid, newChatKey, {
        userType: "gpt",
        message: data.message,
        success: data.success,
        createdAt: new Date(),
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="home">
      <div className="page-container">
        <PWAPrompt
          promptOnVisit={1}
          timesToShow={3}
          copyClosePrompt="Close"
          permanentlyHideOnDismiss={false}
        />
        <ChatToolbar
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
        <div className="chat-log">
          <div className="chat-log-container">
            {chatLog.map((message, index) => (
              <ChatMessage
                key={index}
                message={message}
                effectEnabled={
                  // boolean: enable or disable typewriter effect
                  effectEnabled &&
                  message.success &&
                  index === chatLog.length - 1
                }
                setEffectEnabled={setEffectEnabled}
              />
            ))}
          </div>
        </div>
        <ChatInputPanel
          disabled={loading}
          chatInput={chatInput}
          setChatInput={setChatInput}
          handleSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default Home;
